import styled from "styled-components";

export const Wrapper = styled.div<{ isPopCart?: boolean }>`
    padding: ${({ theme }) => `${theme.spacing.medium} 0 ${theme.spacing.medium}`};
    padding-top: ${(props) => props.isPopCart && props.theme.spacing.small};
`;

export const InstructionsCalloutWrapper = styled.div(({ theme }) => ({
    padding: `0 ${theme.spacing.medium}`,
}));
